module.exports = __webpack_public_path__ + "img/1-3.ce620395.jpeg";